import React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import phone from '../../Assets/Phone Mockup.svg';
import Modal from '../Modal/Modal';

const DownloadSection = () => {
    const { t } = useTranslation();
    const [openModal, setOpenModal] = useState(false);

    return (
        <div id='OurApp' className="bg-yellow-50 dark:bg-Eerie-Black/90 py-16">
            <div className="container m-auto space-y-8 px-6 md:px-12 lg:px-20">
                <div className="items-center justify-center gap-16 text-center md:flex md:text-left">
                    <div className="order-last mb-6 text-right space-y-6 md:mb-0 md:w-7/12 lg:w-6/12">
                        <h1 className="text-4xl font-bold text-Eerie-Black md:text-5xl dark:text-white">
                            {t('DownloadSection.title')}
                        </h1>
                        <p className="text-lg text-Eerie-Black-light dark:text-gray-300">
                            {t('DownloadSection.description')}
                        </p>
                        <div className="flex flex-wrap justify-center gap-4 md:justify-start lg:gap-6">
                            <a
                                target="blank"
                                title={t('DownloadSection.androidLabel')}
                                aria-label="google play"
                                className="block overflow-hidden"
                                onClick={() => setOpenModal(true)}                        
                            >
                            <img
                                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Google_Play_Store_badge_EN.svg/1000px-Google_Play_Store_badge_EN.svg.png"                                    className="object-cover object-top w-32 mx-auto"
                                    alt=""
                                />
                            </a>
                            <a
                                target="blank"
                                title={t('DownloadSection.appleLabel')}
                                aria-label="app store"
                                className="block overflow-hidden"
                                onClick={() => setOpenModal(true)}                        
                            >
                            <img
                            src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Download_on_the_App_Store_Badge.svg/1000px-Download_on_the_App_Store_Badge.svg.png"                            className="object-cover object-top w-32 mx-auto"
                            alt=""
                            />
                            </a>
                        </div>
                        <Modal open={openModal}  onClose={() => setOpenModal(false)} />
                    </div>
                    <img
                        src={phone}
                        width="832"
                        height="608"
                        className="m-auto md:w-5/12"
                        loading="lazy"
                        alt="Phone illustration"
                    />
                </div>
            </div>
        </div>
    );
};

export default DownloadSection;
